import { i18n } from '@lingui/core'
import { Outlet } from 'react-router-dom'
import { useLocation, useNavigate } from 'react-router-dom-original'
import styled from 'styled-components'

import { AppHeader } from '@/@bothrs-ui/web/components/navigation/header/AppHeader'
import { NativePlatform } from '@/capacitor/components/native-platform/NativePlatform'
import { globalDefinitions } from '@/defined-translations'
import { ContentPageLayout } from '@/layout/components/content-page-layout/ContentPageLayout'
import { ContentPagePaddingCSS } from '@/layout/components/content-page-layout/ContentPageLayout.styled'
import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { DocumentList } from '@/modules/documents/components/document-list/DocumentList'

import type { PatientDocumentsFilterOption, PatientViewDocumentsByYear } from '../../types/patient-documents.types'

type Props = {
  documentsByYear: PatientViewDocumentsByYear
  isLoading: boolean
  selectedFilter: PatientDocumentsFilterOption
  unreadFiles?: number
  selectedDocumentId?: string
  setSelectedFilter: (filter: PatientDocumentsFilterOption) => void
  filterMetadataMap: Map<PatientDocumentsFilterOption, number>
  handleDocumentClick: (documentId: string) => void
}
export const DocumentsMobileOverview = ({
  selectedFilter,
  documentsByYear,
  isLoading,
  selectedDocumentId,
  setSelectedFilter,
  filterMetadataMap,
  handleDocumentClick,
}: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  useHideNativeNavigation()

  const isPreviewRoute = location.pathname.includes('/preview/')

  if (selectedDocumentId || isPreviewRoute) {
    return <Outlet context={{ selectedDocumentId }} />
  }

  return (
    <ContentPageLayout
      noScroll
      noPadding
      header={
        <NativePlatform>
          <StMobileHeader>
            <AppHeader
              primaryAction={{
                label: i18n._(globalDefinitions.goBack),
                icon: ['far', 'chevron-left'],
                onClick: () => {
                  navigate('..')
                },
              }}
              title={i18n._(globalDefinitions.document.title)}
              profileButtonEnabled
              enableNotifications
              centered={false}
            />
          </StMobileHeader>
        </NativePlatform>
      }
    >
      <DocumentList
        incomingFilesByYear={documentsByYear}
        isLoading={isLoading}
        selectedFilter={selectedFilter}
        onFilterChange={setSelectedFilter}
        onDocumentClick={handleDocumentClick}
        filterMetadataMap={filterMetadataMap}
      />
    </ContentPageLayout>
  )
}

const StMobileHeader = styled.div`
  ${ContentPagePaddingCSS}
  padding-bottom: 0;
`
